module.exports = __webpack_public_path__ + "media/images/cplook/apple-touch-icon-114x114-b51bcd930229cec15f98901976724a48.png";